import gallery1 from './img/gallery-1.jpg';
import gallery2 from './img/gallery-2.jpg';
import gallery3 from './img/gallery-3.jpg';
import gallery4 from './img/gallery-4.jpg';
import gallery5 from './img/gallery-5.jpg';
import gallery6 from './img/gallery-6.jpg';
import gallery7 from './img/gallery-7.jpg';
import gallery8 from './img/gallery-8.jpg';
import gallery10 from './img/gallery-10.jpg';
import gallery11 from './img/gallery-11.jpg';
import gallery12 from './img/gallery-12.jpg';
import gallery13 from './img/gallery-13.jpg';
import gallery14 from './img/gallery-14.jpg';
import gallery15 from './img/gallery-15.jpg';
import gallery16 from './img/gallery-16.jpg';
import gallery17 from './img/gallery-17.jpg';
import gallery18 from './img/gallery-18.jpg';
import gallery19 from './img/gallery-19.jpg';
import gallery20 from './img/gallery-20.jpg';
import gallery21 from './img/gallery-21.jpg';
import gallery22 from './img/gallery-22.jpg';
import gallery23 from './img/gallery-23.jpg';
import gallery24 from './img/gallery-24.jpg';
import gallery25 from './img/gallery-25.jpg';
import gallery26 from './img/gallery-26.jpg';
import gallery27 from './img/gallery-27.jpg';
import gallery28 from './img/gallery-28.jpg';
 
export default [
	{
        image: gallery1,
        class: "img-b img-fluid"
    },
    {
        image: gallery2,
        class: "img-b img-fluid"
    },
    {
        image: gallery3,
        class: "img-b img-fluid"
    },
    {
        image: gallery4,
        class: "img-b img-fluid"
    },
    {
        image: gallery5,
        class: "img-b img-fluid"
    },
    {
        image: gallery6,
        class: "img-b img-fluid"
    },
    {
        image: gallery7,
        class: "img-b img-fluid"
    },
    {
        image: gallery8,
        class: "img-b img-fluid"
    },
     
    {
        image: gallery10,
        class: "img-b img-fluid"
    },
    {
        image: gallery11,
        class: "img-b img-fluid"
    },
    {
        image: gallery12,
        class: "img-b img-fluid"
    },
    {
        image: gallery13,
        class: "img-b img-fluid"
    },
    {
        image: gallery14,
        class: "img-b img-fluid"
    },
    {
        image: gallery15,
        class: "img-b img-fluid"
    },
    {
        image: gallery16,
        class: "img-b img-fluid"
    },
    {
        image: gallery17,
        class: "img-b img-fluid"
    },
    {
        image: gallery18,
        class: "img-b img-fluid"
    },
    {
        image: gallery19,
        class: "img-b img-fluid"
    },
    {
        image: gallery20,
        class: "img-b img-fluid"
    },
    {
        image: gallery21,
        class: "img-b img-fluid"
    },
    {
        image: gallery22,
        class: "img-b img-fluid"
    },
    {
        image: gallery23,
        class: "img-b img-fluid"
    },
    {
        image: gallery24,
        class: "img-b img-fluid"
    },
    {
        image: gallery25,
        class: "img-b img-fluid"
    },
    {
        image: gallery26,
        class: "img-b img-fluid"
    },
    {
        image: gallery27,
        class: "img-b img-fluid"
    },
    {
        image: gallery28,
        class: "img-b img-fluid"
    }

]